import { render, staticRenderFns } from "./starAnchorModal.vue?vue&type=template&id=2743a868&scoped=true&"
import script from "./starAnchorModal.vue?vue&type=script&lang=js&"
export * from "./starAnchorModal.vue?vue&type=script&lang=js&"
import style0 from "./starAnchorModal.vue?vue&type=style&index=0&id=2743a868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743a868",
  null
  
)

export default component.exports